import * as ActionTypes from 'ActionTypes'

export const getTop = () => {
  return {
    type: ActionTypes.GET_TOP,
  } as const
}
